<script>
import CLogoPage from '../components/CLogoPage.vue'
import CTitle from '../components/CTitle.vue'
import CMessage from '../components/CMessage.vue'

export default {
  name: 'CHomeClosed',

  components: {
    CLogoPage,
    CTitle,
    CMessage
  },

  computed: {
    today: () => new Date(),
    publishAt () {
      return this.$store.state.publishedInfo.publishAt
    },
    unpublishAt () {
      return this.$store.state.publishedInfo.unpublishAt
    },
    readablePublishAt () {
      return this.$store.state.publishedInfo.readablePublishAt
    },
    readableUnpublishAt () {
      return this.$store.state.publishedInfo.readableUnpublishAt
    },
    isPausedByDate () {
      return this.$store.state.publishedInfo.isPausedByDate
    },
    pause_intro_text () {
      return this.$store.state.textsInfo.pauseText
    }
  }
}
</script>
<template>
  <div>
    <c-logo-page />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="pause_intro_text"
      v-html="pause_intro_text"
    />
    <!--eslint-enable-->
    <div v-else>
      <c-title>Hamburger Zukunftsstipendien für Bildende Kunst</c-title>

      <p class="mt-8 mb-8">
        <strong>der Behörde für Kultur und Medien in Kooperation mit der Hamburgischen Kulturstiftung und dem Berufsverband bildender Künstler*innen</strong>
      </p>

      <p class="mb-3">
        Das Verfahren für die Einreichung der Verwendungsberichte für die Hamburger
        Zukunftsstipendien ist abgelaufen. Bei Fragen wenden Sie sich bitte an die Hamburgische
        Kulturstiftung unter Tel. 040 339099 oder per <a href="mailto:zs@kulturstiftung-hh.de">E-Mail</a>.
      </p>
    </div>
    <br>

    <c-message
      type="error"
      class="errors mb-8"
    >
      <p class="mb-3">
        Das Formular kann aktuell nicht ausgefüllt und abgeschickt werden.
        <template v-if="isPausedByDate ">
          <span> Dies </span>
          <span v-if="publishAt > today">ist </span>
          <span v-else-if="unpublishAt < today">war </span>
          im Zeitraum {{ readablePublishAt }} Uhr bis {{ readableUnpublishAt }} Uhr möglich.
        </template>
      </p>
      <router-link
        :to="{ name: 'request' }"
        class="link"
      >
        <span>Sie können sich das Formular ansehen</span>
      </router-link>
      <span class="mb-3">, jedoch nicht absenden.</span>
    </c-message>
  </div>
</template>

<style lang="scss" scoped>
@use "../css/variables.scss";

.link {
  color: variables.$color-red-100;
}
</style>
